/**
 * Map rig signal bus output to scene-local names via preset.bindings.
 * @param {Record<string, number>} raw
 * @param {Record<string, string>} bindings localKey → source signal name
 * @returns {Record<string, number>}
 */
export function resolveSignals(raw, bindings) {
  const out = {};
  if (!bindings) return out;
  for (const [localKey, sourceName] of Object.entries(bindings)) {
    const src = String(sourceName).trim();
    if (!src) continue;
    const v = raw[src];
    out[localKey] = typeof v === 'number' && !Number.isNaN(v) ? v : 0;
  }
  return out;
}
